// config/constants.ts
export const AVATAR_CONFIG = {
  // Tipos de arquivo aceitos
  ACCEPTED_FILE_TYPES: ["image/jpeg", "image/png", "image/webp"] as const,

  // Tamanho máximo em bytes (4MB)
  MAX_FILE_SIZE: 4 * 1024 * 1024,

  // Tamanho máximo em MB para exibição
  MAX_FILE_SIZE_MB: 4,

  // Configurações do cropper
  CROP_ASPECT_RATIO: 1, // Avatar quadrado
  ZOOM_RANGE: {
    min: 1,
    max: 3,
    step: 0.1,
  },

  // Estados iniciais (sem readonly para compatibilidade com setState)
  INITIAL_CROP: { x: 0, y: 0 },
  INITIAL_ZOOM: 1,

  // Mensagens de erro
  ERRORS: {
    INVALID_FILE_TYPE:
      "Por favor, selecione uma imagem válida (JPEG, PNG ou WebP)",
    FILE_TOO_LARGE: "A imagem deve ter no máximo 4MB",
    NO_USERNAME: "Username não encontrado",
    UPLOAD_FAILED: "Falha no upload da imagem. Nenhuma URL retornada.",
    UNKNOWN_ERROR: "Erro desconhecido durante o upload",
  },

  // Textos da interface
  UI_TEXTS: {
    DIALOG_TITLE_UPLOAD: "Carregar nova imagem",
    DIALOG_TITLE_EDIT: "Editar imagem",
    DIALOG_DESCRIPTION:
      "Arraste e solte uma imagem ou clique para selecionar. Formatos aceitos: JPEG, PNG, WebP (máximo 4MB)",
    DROPZONE_MAIN: "Arraste e solte sua imagem aqui",
    DROPZONE_SECONDARY: "ou clique para navegar",
    BUTTON_CANCEL: "Cancelar",
    BUTTON_USE_IMAGE: "Usar imagem",
    BUTTON_UPLOADING: "Enviando...",
  },
} as const;
